/**
 * https://www.figma.com/file/7Gfry5KCHWtM3ur73RKhMu/Question-Indexing-UI?node-id=495%3A6359
 */

import classNames from "classnames";
import React, { ReactElement } from "react";
import { useTranslation } from "next-i18next";
import styles from "./cta.module.scss";
import SocialAuthButtonProvider from "../../../../common/components/socialAuthButtonProvider";
import {
  AppleSigninButton,
  GoogleSigninButton,
} from "@kunduz/feature-onboarding";
import { useAppContext } from "@kunduz/feature-website-context";
import { useRouter } from "next/router";
import { AUTH_PAGEURLS } from "@kunduz/utility-common";

export const SignupSocialCta = (): ReactElement => {
  const { t } = useTranslation("questionIndexing");
  // const { modals } = useAppContext();
  const router = useRouter();

  function handleLoginClick() {
    //router.push(AUTH_PAGEURLS.B2C_SELECT_LOGIN_METHOD);
    if (typeof window !== "undefined") {
      window.location.href = `${AUTH_PAGEURLS.B2C_SELECT_LOGIN_METHOD}?returnUrl=${router.asPath}`;
    }
  }

  return (
    <div className={styles.socialSignupWrapper}>
      <div>
        <div
          className={styles.title}
          dangerouslySetInnerHTML={{
            __html: t(
              "question_indexing_answer_component_signup_state_head_proposition_text",
            ),
          }}
        ></div>
        <ul className={styles.list}>
          <li>
            {t(
              "question_indexing_answer_component_signup_state_first_value_proposition_text",
            )}
          </li>
          <li>
            {" "}
            {t(
              "question_indexing_answer_component_signup_state_second_value_proposition_text",
            )}
          </li>
          <li>
            {t(
              "question_indexing_answer_component_signup_state_third_value_proposition_text",
            )}
          </li>
        </ul>
      </div>
      <div className={classNames(styles.rightColumn)}>
        <SocialAuthButtonProvider type="google" location="Answer">
          <GoogleSigninButton label={t("google_signup_button_label")} />
        </SocialAuthButtonProvider>
        <SocialAuthButtonProvider type="apple" location="Answer">
          <AppleSigninButton label={t("apple_signup_button_label")} />
        </SocialAuthButtonProvider>

        <div
          className={styles.secondaryCta}
          onClick={handleLoginClick}
          dangerouslySetInnerHTML={{
            __html: t(
              "question_indexing_sidebar_component_signup_state_login_text",
            ),
          }}
        />
      </div>
    </div>
  );
};

export default SignupSocialCta;
